import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { LOCALES, DEFAULT_LOCALE } from '~/const/i18n';
import { NEW_RELIC_SCRIPT_SET } from '~/store/modules/script/types';
export default {
  nuxtServerInit(_ref, _ref2) {
    var _this = this;

    return _asyncToGenerator(function* () {
      var {
        commit,
        dispatch
      } = _ref;
      var {
        params,
        req
      } = _ref2;
      var response = yield _this.$axios.post('/new-relic/script', {});
      if (response && response.data && response.data.newRelicScript) commit(NEW_RELIC_SCRIPT_SET, response.data.newRelicScript);
      dispatch('detectSearchEngine', req.headers['user-agent']);
      var locale = LOCALES.filter(obj => obj.market === params.market).find(obj => obj.language === params.language) || DEFAULT_LOCALE;
      commit('i18n/SET_LOCALE', locale);
      _this.app.i18n.locale = locale.language;
      var protocol = 'http';

      if (req && req.headers && req.headers['x-forwarded-proto']) {
        protocol = req.headers['x-forwarded-proto'];
      }

      var baseURL = req ? "".concat(protocol, "://").concat(req.headers.host) : '';
      commit('request/SET_BASE_URL', baseURL);
    })();
  }

};